var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schoolBasic"},[_c('b',{staticClass:"txt-lh36 txt-111 rel"},[_vm._v("\n        "+_vm._s(_vm.classInfo.name))]),_vm._v(" "),_c('p',{staticClass:"txt-lh28 txt-666 mt15 pl35 time"},[_vm._v("\n        "+_vm._s(_vm.classInfo.time)+"／"+_vm._s(_vm.classInfo.courseTotal)+"课次\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee93a00","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/courseCenter/newsign/SchoolBasic.vue
// module id = null
// module chunks = 